import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { NavList } from 'modules/common';
import { noop } from 'core/utilities';
import '../list-header.scss';

import { useSelector } from 'react-redux';
import { profileCandidateSelector } from 'core/login';
import { isMobileDevice } from 'react-select/dist/index-ea9e225d.cjs.prod';
import classnames from 'classnames';


function NavTabs({
  title,
  activeTabKey,
  activeTabKeyName = 'activeTabKey',
  onChangeFilter,
  navTabs = [],
  disabled = false,
  children = null,

  isTabLinked = false,

  classNameContainer,
}) {
  const profileCandidate = useSelector(profileCandidateSelector);
  const getNavListHref = useCallback(
    nav => {
      return isMobileDevice() && nav.url
        ? `/${profileCandidate.organization_revv_uid}${nav.url}`
        : nav?.isNewTabAble
        ? `#${nav.value}`
        : null;
    },
    [isMobileDevice, profileCandidate.organization_revv_uid]
  );
  return (
    <Row
      className={classnames({
        'justify-content-center mt-4': !classNameContainer,
        [classNameContainer]: classNameContainer,
      })}
    >
      <Col lg="11" className="header-subheader">
        <div className="nav-list">
          {!navTabs || navTabs.length > 0 ? (
            <NavList
              activeKey={activeTabKey}
              onSelect={
                disabled
                  ? noop
                  : (value, event) =>
                      onChangeFilter({ target: { name: activeTabKeyName, value } }, isTabLinked ? event : true)
              }
              ariaLabel={`preset filters for ${title}`}
            >
              {navTabs.map(nav => {
                if (nav.isHidden) return null;

                return (
                  <NavList.Item href={getNavListHref(nav)} key={nav.value} eventKey={nav.value} disabled={disabled}>
                    {nav.label}
                  </NavList.Item>
                );
              })}
            </NavList>
          ) : null}
        </div>
        {children}
      </Col>
    </Row>
  );
}

NavTabs.propTypes = {
  title: PropTypes.any.isRequired,
  activeTabKey: PropTypes.string,
  onChangeFilter: PropTypes.func,
  navTabs: PropTypes.any,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  isTabLinked: PropTypes.bool,
  classNameContainer: PropTypes.string,
};

export default NavTabs;
